import { DiscoverBadge, DiscoverBadgeTypes } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { InContextPromoAlert } from '@webapp/platform/discover-more/components/InContextPromoAlert'
import messages from './messages'
import { useApPoExportPromoPresenter } from './useApPoExportPromoPresenter'

export interface IApPoExportPromoPresenterProps {
  recordCount: number
  onNavigate?: (path: string) => void
}

export const ApPoExportPromoPresenter = ({
  recordCount,
  onNavigate,
}: IApPoExportPromoPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    states: { isEligible },
    commands: { onLearnMoreClick, onLaterClick },
  } = useApPoExportPromoPresenter({ recordCount, onNavigate })

  if (!isEligible) return null

  return (
    <InContextPromoAlert
      analyticsId='ap-po-export-promo'
      badge={
        <DiscoverBadge
          type={DiscoverBadgeTypes.ADD_ON}
          text={intl.formatMessage(messages.badge)}
        />
      }
      headline={intl.formatMessage(messages.headline, { recordCount })}
      body={intl.formatMessage(messages.body)}
      learnMoreText={intl.formatMessage(messages.learnMore)}
      laterText={intl.formatMessage(messages.later)}
      onLearnMoreClick={onLearnMoreClick}
      onLaterClick={onLaterClick}
    />
  )
}

ApPoExportPromoPresenter.displayName = 'ApPoExportPromoPresenter'
